import APIService from 'services/APIService'

const api = APIService()

export const getAbandonedCartStatus = token =>
  api.get(`/abandoned-cart/${token}`)

export const optOutAbandonedCart = token =>
  api.post(`/abandoned-cart/${token}/opt-out`)

export const confirmAbandonedCartDeletion = token =>
  api.post(`/abandoned-cart/${token}/confirm-deletion`)
